/* 🤖 this file was generated by svg-to-ts */
export const matIconAcUnit: {
  name: 'ac-unit';
  data: string;
} = {
  name: 'ac-unit',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22v-2z"/></svg>`
};
